module.exports = __webpack_public_path__ + "media/images/emblems/Arzier-coat_of_arms-a7cdd58d65688687315d7c56c6750815.svg";